import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Danhmucdonvi from "components/Danhmuc/Donvi/Danhmucdonvi.js";
export default function Dmloaidonvi() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Đơn vị",
            tabContent: <Danhmucdonvi />,
          },
        ]}
      />
    </div>
  );
}
